import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, Center } from '@chakra-ui/react'
import { Spinner } from '@/components/atoms/Spinner'

export const LoadingModal = ({ onClose, title }: { onClose: () => void; title: string }) => {
  return (
    <Modal size={'lg'} isCentered={true} isOpen={true} onClose={onClose} closeOnEsc={false} closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent marginLeft={2.5} marginRight={2.5}>
        <ModalHeader pb={2} fontSize="xl" fontWeight="700">
          {title}
        </ModalHeader>
        <ModalBody pb={5}>
          <Center>
            <Spinner />
          </Center>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}
